import { CatalogPackagesApiResponse } from "app/types/catalogs";
import {
  CatalogImportApiResponse,
  CatalogImportConfirmApiResponse,
  CatalogImportConfirmPayload,
  CatalogImportLogDetailResponse,
  CatalogImportLogsListResponse,
  CatalogImportPayload,
  GetCatalogImportLogsParams,
} from "app/types/catalog-import";
import axios from "./config";
import { createQuery } from "app/utils/constants/common";
import { AxiosResponse } from "axios";

export const getCatalogsAPI = (payload?: any) => {
  let query = "";

  if (payload) {
    query = "?" + createQuery({ filter: payload });
  }

  return axios.get(`/catalogs${query}`);
};

export const createCatalogAPI = (payload: object) =>
  axios.post(`/catalogs`, payload);

export const updateCatalogAPI = (catalogId: number, payload: object) =>
  axios.put(`/catalogs/${catalogId}`, payload);

export const deleteCatalogAPI = (catalogId: number) =>
  axios.delete(`/catalogs/${catalogId}`);

export const detailCatalogMenuAPI = (catalogId: number) =>
  axios.get(`/catalogs/${catalogId}`);

export const createCatalogMenuAPI = (catalogId: number, payload: object) =>
  axios.post(`/catalogs/${catalogId}/Menus`, payload);

export const updateCatalogMenuAPI = (
  catalogId: number,
  payload: object,
  menuId: number
) => axios.put(`/catalogs/${catalogId}/menus/${menuId}`, payload);

export const deleteMenuAPI = (menuId: number, catalogId: number) =>
  axios.delete(`/catalogs/${catalogId}/menus/${menuId}`);

export const getMenuByIdAPI = (catalogId: number, menuId: number) =>
  axios.get(`/catalogs/${catalogId}/menus/${menuId}`);

export const addMealIntoMenuAPI = (
  catalogId: number,
  menuId: number,
  payload: any
) => axios.post(`/catalogs/${catalogId}/menus/${menuId}/meals`, payload);

export const deleteMealIntoMenuAPI = (
  catalogId: number,
  menuId: number,
  mealName: string,
  classification: string,
  dishId: number
) =>
  axios.delete(
    `/catalogs/${catalogId}/menus/${menuId}/dishes/${dishId}/meals/${mealName}?classification=${classification}`
  );

export const getCatalogPackagesAPI = (
  catalogId: number
): Promise<AxiosResponse<CatalogPackagesApiResponse>> =>
  axios.get<CatalogPackagesApiResponse>(`/catalogs/${catalogId}/packages`);

export type CreateCatalogPackagesAPIPayload = {
  availableFrom: string;
  availableUntil: string;
  packageIds: number[];
};

export const createCatalogPackagesAPI = (
  catalogId: number,
  payload: CreateCatalogPackagesAPIPayload
) => axios.post(`/catalogs/${catalogId}/packages`, payload);

export const importCatalogAPI = (
  catalogId: number,
  payload: CatalogImportPayload
): Promise<AxiosResponse<CatalogImportApiResponse>> =>
  axios.post<CatalogImportApiResponse>(
    `/catalogs/${catalogId}/import`,
    payload
  );

export const confirmCatalogImportAPI = (
  catalogId: number,
  payload: CatalogImportConfirmPayload
): Promise<AxiosResponse<CatalogImportConfirmApiResponse>> =>
  axios.post<CatalogImportConfirmApiResponse>(
    `/catalogs/${catalogId}/import/confirm`,
    payload
  );

export const getCatalogImportLogsAPI = (
  catalogId: number,
  params?: GetCatalogImportLogsParams
): Promise<AxiosResponse<CatalogImportLogsListResponse>> => {
  const searchParams = new URLSearchParams();
  if (params?.status) {
    searchParams.set("status", params.status);
  }
  if (params?.limit) {
    searchParams.set("limit", String(params.limit));
  }
  if (params?.continutationToken) {
    searchParams.set("continutationToken", params.continutationToken);
  }
  const query = searchParams.toString();
  return axios.get<CatalogImportLogsListResponse>(
    `/catalogs/${catalogId}/import-logs${query ? `?${query}` : ""}`
  );
};

export const getCatalogImportLogDetailAPI = (
  catalogId: number,
  logId: number
): Promise<AxiosResponse<CatalogImportLogDetailResponse>> =>
  axios.get<CatalogImportLogDetailResponse>(
    `/catalogs/${catalogId}/import-logs/${logId}`
  );
